module.exports = __webpack_public_path__ + "img/VoyagePlanning.d0892513.jpg";